export default __webpack_public_path__ + "static/media/table_cancer_screening_PC_En.1e381c83.webp";